import {
  IconCash,
  IconFirstAidKit,
  IconFlask,
  IconStethoscope,
  IconUsers,
} from '@tabler/icons-react';
import type { ReactNode } from 'react';

import { useAppearance } from '@/app/appearance/appearance-context';
import { AppIcon } from '@/components/AppIcon';

const APP_NAME = 'GestClinic';

/**
 * Écran d'accueil en deux panneaux (comme « Gestion Bulletins ») : présentation à
 * gauche sur fond dégradé à motifs, formulaire à droite.
 */
export function AuthShell({ children }: { children: ReactNode }) {
  const { clinicName } = useAppearance();
  return (
    <div className="auth">
      <div className="auth-hero">
        <div className="auth-brand">
          <div className="auth-logo">
            <IconFirstAidKit
              size={38}
              stroke={2}
              color="var(--accent-light, #0e7765)"
              aria-hidden
            />
          </div>
          <div>
            <div className="auth-app">{APP_NAME}</div>
            {clinicName && <div className="auth-ecole">{clinicName}</div>}
          </div>
        </div>
        <h1 className="auth-h">
          Le parcours de vos patients,
          <br />
          <span>du rendez-vous à la facture.</span>
        </h1>
        <ul className="auth-feats">
          <li>
            <AppIcon icon={IconUsers} color="#7c3aed" size={30} />
            Accueil, rendez-vous et dossiers patients
          </li>
          <li>
            <AppIcon icon={IconStethoscope} color="#0891b2" size={30} />
            Consultations, soins, urgences et hospitalisation
          </li>
          <li>
            <AppIcon icon={IconFlask} color="#ea580c" size={30} />
            Laboratoire, imagerie, pharmacie et stocks
          </li>
          <li>
            <AppIcon icon={IconCash} color="#16a34a" size={30} />
            Facturation, caisse, assurances et rapports
          </li>
        </ul>
        <div className="auth-foot">{APP_NAME} V1.0 · Données médicales protégées et tracées</div>
      </div>
      <div className="auth-panel">{children}</div>
    </div>
  );
}
